module.exports = __webpack_public_path__ + "d478856bfb090d89128e3074f48f9ace.svg";